<!--银企直贷-->
<template>
  <div class="loan-container">
    <header-index/>
    <div class="loan-content">
      <div class="loan-top">
        <div class="el-top-menu">
          <h1 class="loan-top-title"><!--{{childNode.name}}-->企业融资服务平台</h1>
          <el-button class="about-platform" round @click="getAboutPlatform">关于平台<i class="el-icon-right el-icon--right"></i></el-button>
        </div>
      </div>
      <div class="loan-center">
        <div class="loan-item">
          <p class="loan-bold-span">{{ ShopStatistics.yqzdShopNum }}</p>
          <p class="loan-normal-span">金融机构</p>
        </div>
        <div class="loan-item">
          <p class="loan-bold-span">{{ ShopStatistics.yqzdShopGoodsNum }}</p>
          <p class="loan-normal-span">融资产品</p>
        </div>
        <div class="loan-item">
          <p class="loan-bold-span">{{ ShopStatistics.yqzdLoanAmount }}</p>
          <p class="loan-normal-span">放款金额(万元)</p>
        </div>
        <div class="loan-item">
          <p class="loan-bold-span">82</p>
          <p class="loan-normal-span">申请企业</p>
        </div>
      </div>
      <div class="loan-info" :style="'min-height:'+min_height+'px;'">
        <p class="small-title">全部产品</p>
        <div class="loan-list" v-if="tablePage.total>0">
          <el-row :gutter="16">
            <el-col :span="8" v-for="list of loanData">
              <div class="loan-info-content" @click="serviceDetail(list)">
                <div class="loan-child-1">
                  <el-image :src="list.logo" class="el-avatar-loan"/>
                  <p class="loan-name">{{ list.company }}</p>
                  <el-divider direction="vertical" class="loan-divider"/>
                  <p class="loan-bold">{{ list.name }}</p>
                </div>
                <div class="loan-child-bottom">
                  <div class="loan-child-li">
                    <p class="loan-red-p">{{list.apr}}</p>
                    <p class="loan-normal-p">年利率</p>
                  </div>
                  <div class="loan-child-li">
                    <p class="loan-red-p">{{ list.maximumAmount }}万</p>
                    <p class="loan-normal-p">最高额度</p>
                  </div>
                  <div class="loan-child-li">
                    <p class="loan-red-p">{{list.repaymentPeriod}}个月</p>
                    <p class="loan-normal-p">贷款期限</p>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
          <!-- 分页 -->
          <page :total="tablePage.total" class="pagination" @currentPage="currentPage" :page="tablePage.currentPage"
                :limit="tablePage.pageSize" style="padding: 10px 25px 15px 10px;"/>
        </div>
        <div class="loan-list" v-else>
          <el-empty description="暂无产品"/>
        </div>
      </div>
    </div>
    <home_footer/>
    <Hang/>
    <el-dialog title="关于平台" :visible.sync="dialogVisible" class="dialog" width="35%">
      <p class="dialog-title">{{childNode.name}}企业融资服务平台</p>
      <p class="dialog-content"><span>简介：</span><span>{{aboutUs.content}}</span></p>
      <p class="dialog-item"><span>指导单位：</span><span>{{aboutUs.operator}}</span></p>
      <p class="dialog-item"><span>运营主体：</span><span>{{aboutUs.guideUnit}}</span></p>
    </el-dialog>
  </div>
</template>

<script>
import headerIndex from "@/components/header/headerIndex";
import home_footer from "@/components/footer/home_footer";
import Hang from "@/components/Hang/Hang";
import page from "@/components/page/pages";
import {yqzdServicePageList,yqzdShopStatistics,aboutPlatform} from '@/api/loanApi'
export default {
  name: "index",
  components:{headerIndex,home_footer,Hang,page},
  data(){
    return{
      cid:0,
      min_height: document.documentElement.clientHeight - 315,
      childNode:{"id": 2, "name": "渝北区", "cityCode": 500112, "municipalityCode": 500100, "parentCityCode": 500000, "level": 2, "cityPinyin": "yubeiqu"},
      loanData:[],
      tablePage: {
        currentPage: 1,
        pageSize: 9,
        total: 0,
      },
      ShopStatistics:{},
      dialogVisible:false,
      aboutUs:{},
      pName: '',
    }
  },
  methods:{
    /*获取银企服务数据*/
    getLoanInfo(){
      yqzdServicePageList({
        cityCode: this.childNode.parentCityCode,
        page: this.tablePage.currentPage,
        pageLimit: this.tablePage.pageSize,
        uid: this.cid != 0 && this.cid != undefined ? this.cid : 0
      }).then(res=>{
        if (res.code==200){
          this.loanData=res.content.rows;
          this.tablePage.total=res.content.total;
        }
      })
    },
    //切换分页
    currentPage(page) {
      this.tablePage.currentPage = page;
      this.getLoanInfo();
    },
    /*获取银企服务统计数据*/
    getShopStatistics(){
      yqzdShopStatistics({
        cityCode: this.childNode.parentCityCode,
        request: 'form',
        uid: this.cid != 0 && this.cid != undefined ? this.cid : 0
      }).then(res=>{
        if (res.code==200){
          this.ShopStatistics=res.content;
        }
      })
    },
    /*获取关于银企服务平台信息*/
    getAboutPlatform(){
      aboutPlatform({
        cityCode: this.childNode.parentCityCode,
        request: 'form',
        uid: this.cid != 0 && this.cid != undefined ? this.cid : 0
      }).then(res=>{
        if (res.code==200){
          if (res.content.ptAboutPlatform){
            this.dialogVisible=true;
            this.aboutUs=res.content.ptAboutPlatform;
          }else{
            this.$alert('暂无'+this.childNode.name+'企业融资服务平台相关信息')
          }
        }
      })
    },
    /*银企服务详情*/
    serviceDetail(row){
      this.$router.replace({
        path: '/loan/serviceDetails',
        query: {
          city: this.childNode.cityCode,
          cityName: this.childNode.name,
          id: row.id,
          pName:this.childNode.name+'企业数字化服务云平台',
          backIndex:2,
        }
      })
    }
  },
  mounted() {
    this.getLoanInfo();
    this.getShopStatistics();
  },
  beforeMount() {
    this.cid = sessionStorage.getItem('loginData') != '' && sessionStorage.getItem('loginData') != null && sessionStorage.getItem('loginData') != undefined ? JSON.parse(sessionStorage.getItem('loginData')).cid : 0;
    if (sessionStorage.getItem('childNode')) {
      this.childNode = JSON.parse(sessionStorage.getItem('childNode'));
    }
  }
}
</script>
<style scoped>
/* 设置dialog弹出框的样式 */
.loan-container >>> .dialog .el-dialog__header {
  border-bottom: 1px solid #DDDDDD;
  padding: 10px 20px;
  background: #ffffff;
  border-radius: 10px 10px 0px 0px;
  vertical-align: middle;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
/* 弹出框标题字体 */
.loan-container >>> .dialog .el-dialog__title {
  font-size: 16px;
  font-family: 'SourceHanSansCN';
  color: #222222;
}
.loan-container >>> .dialog .el-dialog__headerbtn {
  position: relative;
  padding: 0px;
  background: center;
  border: none;
  outline: 0;
  cursor: pointer;
  top: auto;
  right: auto;
  font-size: 16px;
}
.loan-container >>> .dialog .el-dialog__body {
  padding: 0px 20px 20px;
  color: #606266;
  font-size: 14px;
}
</style>
<style scoped lang="scss">
.loan-container{
  background: #ffffff;
  .loan-content{
    .loan-top{
      background: url("~@/assets/img/recruit/loan.png") no-repeat;
      background-size: 100% 100%;
      height: 400px;
      display: flex;
      min-width: 76rem;
      justify-content: left;
      align-items: center;
      padding:0px 18%;
      .el-top-menu{
        .loan-top-title {
          color: #ffffff;
          font-size: 48px;
          font-family: "SourceHanSansCN";
          margin-block-end: 0px;
          margin-block-start: 0px;
          cursor: pointer;
        }
        .about-platform{
          color: #110D40;
          font-size: 14px;
          font-family: "SourceHanSansCN";
          margin-top: 20px;
          padding: 12px 20px;
          width: auto;
          .el-icon-right{
            font-size: 16px;
            font-family: "SourceHanSansCN";
            color: #110D40;
            font-weight: bold;
            padding-left: 5px;
          }
        }
      }
    }
    .loan-center{
      margin: -50px 18% 0px;
      background: #ffffff;
      display: flex;
      box-shadow: 4px -4px 6px 0px rgb(231 233 245 / 60%);
      justify-content: space-around;
      align-items: center;
      text-align: center;
      padding: 20px;
      cursor: pointer;
      min-width: 76rem;
      .loan-bold-span{
        margin-block-end: 0px;
        margin-block-start: 0px;
        color: #333333;
        font-family: 'SourceHanSansCN';
        font-size: 24px;
      }
      .loan-normal-span{
        margin-block-end: 0px;
        margin-block-start: 0px;
        font-family: 'SourceHanSansCN';
        font-size: 16px;
        color: #666666;
      }
    }
    .loan-info{
      margin: -50px 0px 2px 18%;
      padding: 70px 18% 0px 0px;
      min-width: 76rem;
      background: #ffffff;
      .small-title{
        margin-block-end: 0px;
        margin-block-start: 0px;
        color: #333333;
        font-family: 'SourceHanSansCN';
        font-size: 24px;
      }
      .loan-list{
        .loan-info-content{
          background: #F2F3FB;
          padding: 20px;
          margin-top: 20px;
          border-radius: 6px;
          .loan-child-1{
            margin-block-end: 0px;
            margin-block-start: 0px;
            margin-bottom: 20px;
            display: flex;
            justify-content: left;
            align-items: center;
            .el-avatar-loan{
              margin-right: 10px;
              width: 65px;
              height: 20px;
              object-fit: cover;
              border-radius: 50%;
            }
            .loan-name{
              font-weight: 100;
              font-family: 'SourceHanSansCN';
              font-size: 16px;
              color: #333333;
              margin-block-end: 0px;
              margin-block-start: 0px;
              text-overflow: ellipsis;
              -webkit-line-clamp: 1;
              word-break: break-all;
              overflow: hidden;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              width: 100%;
            }
            .loan-bold{
              font-family: "SourceHanSansCN";
              font-size: 16px;
              font-weight: 600;
              color: #333333;
              margin-block-end: 0px;
              margin-block-start: 0px;
              text-overflow: ellipsis;
              -webkit-line-clamp: 1;
              word-break: break-all;
              overflow: hidden;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              width: 100%;
            }
            .loan-divider{
              background-color: #999999;
            }
          }
          .loan-child-bottom{
            display: flex;
            justify-content: space-between;
            align-items: center;
            .loan-child-li{
              padding: 0px 10px 0px 0px;
              .loan-red-p{
                color: #FE273B;
                font-size: 14px;
                font-family: 'SourceHanSansCN';
                margin-block-end: 0px;
                margin-block-start: 0px;
              }
              .loan-normal-p{
                margin-block-end: 0px;
                margin-block-start: 0px;
                font-size: 14px;
                color: #333333;
                font-family: 'SourceHanSansCN';
              }
            }
          }
        }
      }
    }
  }
  .dialog{
    .dialog-title{
      font-size: 18px;
      color: #333333;
      margin-block-start: 20px;
      margin-block-end: 20px;
      font-family: "SourceHanSansCN";
    }
    .dialog-content{
      font-size: 14px;
      color: #333333;
      margin-block-start: 0px;
      margin-block-end: 20px;
      font-family: "SourceHanSansCN";
    }
    .dialog-item{
      font-size: 14px;
      color: #333333;
      margin-block-start: 0px;
      margin-block-end: 8px;
      font-family: "SourceHanSansCN";
    }
  }
}
</style>